/**
 * Bundle optimization utilities
 */

// Preload critical resources
export const preloadCriticalResources = () => {
    // Preload critical fonts
    const fontLink = document.createElement('link');
    fontLink.rel = 'preload';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
    fontLink.as = 'style';
    fontLink.onload = function () { this.rel = 'stylesheet'; };
    document.head.appendChild(fontLink);
};

// Optimize images for different screen sizes
export const getOptimizedImageUrl = (url, width = 800, quality = 80) => {
    if (!url) return null;

    // If it's already optimized or a placeholder, return as-is
    if (url.includes('placeholder') || url.includes('unsplash')) {
        return url;
    }

    // Add optimization parameters for supported services
    if (url.includes('cloudinary.com')) {
        return url.replace('/upload/', `/upload/w_${width},q_${quality},f_auto/`);
    }

    return url;
};

// Debounce function for search optimization
export const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

// Cache management for API responses
export const createCache = (maxSize = 50) => {
    const cache = new Map();

    return {
        get: (key) => cache.get(key),
        set: (key, value) => {
            if (cache.size >= maxSize) {
                const firstKey = cache.keys().next().value;
                cache.delete(firstKey);
            }
            cache.set(key, value);
        },
        has: (key) => cache.has(key),
        clear: () => cache.clear()
    };
};

// Performance monitoring
export const measurePerformance = (name, fn) => {
    return async (...args) => {
        const start = performance.now();
        const result = await fn(...args);
        const end = performance.now();

        if (process.env.NODE_ENV === 'development') {
            console.log(`${name} took ${end - start} milliseconds`);
        }

        return result;
    };
};